import { render, staticRenderFns } from "./ContentReportList.vue?vue&type=template&id=0df8a7aa&scoped=true"
import script from "./ContentReportList.vue?vue&type=script&lang=js"
export * from "./ContentReportList.vue?vue&type=script&lang=js"
import style0 from "./ContentReportList.vue?vue&type=style&index=0&id=0df8a7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8a7aa",
  null
  
)

export default component.exports